export default __webpack_public_path__ + "static/media/logo.a6a9db2a.svg";